import { Button, Typography } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { RouteConstants } from '../../navigation/navigation-types'

const Unauthenticated: React.FC = () => {
    const navigate = useNavigate()

    return (
        <div>
            <Typography variant='h5'>Omlouváme se ale nejste přihlášený</Typography>
            <Button
                variant='contained'
                onClick={() => {
                    navigate(RouteConstants.login, { replace: true })
                }}
            >
                Zpět k přihlášení
            </Button>
        </div>
    )
}

export default Unauthenticated
